import server from "./server";

export const getServicesApi = async () => {
  const response = await server().get("/services");
  return response.data;
};

export const getSingleServiceApi = async ({ slug }) => {
  const response = await server().get(`/services/slug/${slug}`);
  return response.data;
};

export const getSingleServiceByIdApi = async ({ id }) => {
  const response = await server().get(`/services/${id}`);
  return response.data;
};

export const createServiceApi = async ({ data }) => {
  const response = await server().post("/services", data);
  return response.data;
};

export const updateServiceApi = async ({ id, data }) => {
  const response = await server().put(`/services/${id}`, data);
  return response.data;
};

export const deleteServiceApi = async ({ id }) => {
  const response = await server().delete(`/services/${id}`);
  return response.data;
};
